import axios from 'axios';

const notificationApi = {
  async getNotifications() {
    const response = await axios.get('/api/tenant/notification');
    return response.data;
  },
  async setRead(id) {
    const response = await axios.post(`/api/tenant/notification/${id}/read`, {});
    return response.data;
  }


};

export default notificationApi;
